export default {
  isManual: '',
  orderDetailsView: {},
  orderNo: '',
  confirmation: {},
  errorInfo: {
    status: false,
    msg: '',
  },
};
